<template>
    <layout>
        <TitleLable parentMessage="考试设置"></TitleLable>
        <el-form class="exam_form" ref="form" :model="form">
            <el-form-item>
                <span style="margin-right: 5px;line-height: 32px;height: 32px;float: left;margin-top: 5px;color: #606266;">交卷时间：</span>
                <el-input style="float: left;" size="small" v-model="form.allowtime"></el-input>
                <span style="margin-left: 10px;line-height: 32px;height: 32px;float: left;margin-top: 5px;color: #606266;">分钟后可以交卷</span>
                <el-link style="display: inline-block;width: 100%;" type="danger" :underline="false">* 不设置时间表示做完即可交卷，设置时间后需要等到对应的时间后可交卷</el-link>
            </el-form-item>
            <el-form-item label="关联分层：" label-width="85px">
                <el-radio-group @change="changeStratify" v-model="form.stratify">
                    <el-radio label="0">不关联</el-radio>
                    <el-radio label="1">关联</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.stratify == '1'" label="分层选择：" label-width="85px">
                <el-radio-group v-model="form.stratify_name">
                    <el-radio v-for="(item,index) in stratify_data" :key="index" :label="item.name">{{ item.name }}层</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="防作弊：" label-width="85px">
                <el-checkbox v-model="form.cheat">选项随机排序</el-checkbox>
                <!-- <el-radio-group v-model="form.cheat">
                    <el-radio label="0">材料随机抽取</el-radio>
                    <el-radio label="1">选项随机排序</el-radio>
                </el-radio-group> -->
            </el-form-item>
        </el-form>
        <TitleLable parentMessage="考题设置"></TitleLable>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="题型设置" name="first">
                <div class="type_box">
                    <span class="trem" v-show="item.value != 8" v-for="(item,index) in type_data" :key="index" @click="clickType(item)" :style="type_change_data.includes(item.value)?'background-color:#409eff;color:#ffffff':''">{{ item.name }}</span>
                </div>
                <div class="question_sign"><i style="color: #f56c6c;font-size: 18px;display: inline-block;margin-right: 10px;" class="el-icon-info"></i>百分制计算，每个题型可选择多篇材料，但只会从每个题型中随机抽取一篇作为试卷的一部分（防作弊），每种题型的分值设置需要合理计算，总分不得超过一百分，比如有A B C三种题型，每种题型抽取一篇材料的总分不得超过一百</div>
                <div class="question_box">
                    <div v-for="(item,index) in list" :key="index">
                        <div @click="clickQuestionType(index)" class="question_title_box">
                            <el-row>
                                <el-col :span="2">
                                    <span >{{ item.name }}</span>
                                </el-col>
                                <el-col :span="2">
                                    <span >设置数量：{{ item.number }}</span>
                                </el-col>
                                <el-col :span="4">
                                    <!-- <span class="grid-content">设置材料
                                        <el-select style="width: 70px;margin-left: 5px;margin-right: 5px;" size="small" v-model="value" >
                                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>篇
                                    </span> -->
                                    <span class="grid-content">设置材料<el-input style="width: 70px;margin-left: 5px;margin-right: 5px;" size="small" @input="inputSetnumber(index)" v-model="list[index].set_number" placeholder=""></el-input>篇</span>
                                </el-col>
                                <el-col :span="10">
                                    <span class="grid-content">设置题型总分数<el-input style="width: 70px;margin-left: 5px;margin-right: 5px;" size="small" @input="inputScore(index)" v-model="list[index].score" placeholder=""></el-input>分</span>
                                </el-col>
                                <el-col :span="4">
                                    <el-link type="primary" @click="changeQuestion(item.value)" :underline="false">选题</el-link>
                                    <el-link type="danger" @click="delParent(index,item.value)" :underline="false">删除</el-link>
                                </el-col>
                            </el-row>
                        </div>
                        <el-collapse-transition>
                            <div v-show="index == question_index">
                                <div class="transition-box">

                                    <el-row class="question_list_title">
                                        <el-col :span="2"><div class="grid-content">序号</div></el-col>
                                        <el-col :span="4"><div class="grid-content">来源</div></el-col>
                                        <el-col :span="6"><div class="grid-content">题干</div></el-col>
                                        <el-col :span="4"><div class="grid-content">题量</div></el-col>
                                        <el-col :span="4"><div class="grid-content">分值</div></el-col>
                                        <el-col :span="2"><div class="grid-content">操作</div></el-col>
                                    </el-row>

                                    <el-row v-for="(qitem,qindex) in item.items" :key="qindex" class="question_list">
                              
                                        <el-col :span="2"><div class="grid-content">{{ qindex+1 }}</div></el-col>
                                        <el-col :span="4"><div class="grid-content">{{ qitem.source }}</div></el-col>
                                        <el-col :span="6"><div style="line-height: 25px;" class="grid-content">{{ qitem.title }}</div></el-col>
                                        <el-col :span="4"><div class="grid-content">{{ qitem.number }}</div></el-col>
                                        <el-col :span="4"><div class="grid-content"><el-input style="width: 70px;" disabled size="small" @input="inputNumber(index,qindex)" placeholder="分值" v-model="list[index].items[qindex].score"></el-input></div></el-col>
                                        <el-col :span="2"><div class="grid-content"><el-link type="danger" @click="delList(index,qindex)" :underline="false">删除</el-link></div></el-col>
                                    </el-row>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </div>
                    
                </div>
            </el-tab-pane>
            
            <div v-if="list.length" style="width: 100%;display: inline-block;text-align: center;">
                <el-button size="small" @click="submit" class="el-icon-edit" type="primary"> 确认发布</el-button>
                <el-button size="small" @click="preview" class="el-icon-monitor" type="success"> 试卷预览</el-button>
            </div>
        </el-tabs>

        <el-dialog
            title="试卷预览"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
                <div v-for="(item,index) in bank_data" :key="index" class="content_paper">

                    <h3 style="color: #000000;">{{ item.title }}</h3>
                    <div style="color: #000000;line-height: 25px;" v-html="item.body"></div>

                    <div v-show="item.option" v-for="(test_item,test_index) in item.test" :key="test_index">
                        
                        <div >
                            <div style="color: #000000;line-height: 60px;" >{{test_index+1 }}、{{ test_item.question }}</div>
                            <div :style="!answeritem || answeritem =='/'?'display:none':''" v-for="(answeritem,answerindex) in test_item.answer" :key="answerindex" class="question_test" >{{ test_options[answerindex] }}. {{ answeritem }}</div>
                        </div>
                        <div style="color: #000000;line-height: 60px;" >参考答案：{{ test_item.r_answer }}</div>
                    </div>
                    <div v-show="!item.option">
                        <div style="color: #000000;line-height: 30px;" >参考答案：{{ item.test.length?item.test:item.answer }}</div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
        </el-dialog>
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/exam";
export default {
    components:{
        TitleLable
    },
    data(){
        return{
            test_options:['A','B','C','D'],
            pdoptions:['T','F'],
            number:'',
            show3:false,
            trem:'',
            type_index:0,
            dialogVisible:false,
            form:{
                allowtime:'',
                stratify:'0',
                cheat:false,
                stratify_name:''
            },
            options: [],
            type_data:[
                {
                    value:1,
                    name:'单项选择'
                },
                {
                    value:2,
                    name:'阅读理解'
                },
                {
                    value:3,
                    name:'完型填空'
                },
                {
                    value:4,
                    name:'匹配题'
                },
                {
                    value:5,
                    name:'单词变形'
                },
                {
                    value:6,
                    name:'写作题'
                },
                {
                    value:7,
                    name:'翻译题'
                },
                {
                    value:8,
                    name:'听力题'
                },
                {
                    value:9,
                    name:'判断题'
                }
            ],
            list:[],
            question_index:0,
            activeName:'first',
            question_ids:'',//材料ID
            type_value:0,   //选择添加的题型
            bank_index:0,   //题库0 阅读理解 1应试英语 
            type_change_data:[],
            stratify_data:[],    //分层
            grade:'',
            bank_data:[]
        }
    },
    created(){
        
    },
    // beforeRouteLeave(to, from, next) {
    //     console.log('离开当前组件');
    //     // 可以在这里执行一些逻辑，比如提示用户保存数据
    //     const confirmLeave = confirm('您确定要离开吗？未保存的更改可能会丢失。');
    //     if (confirmLeave) {
    //     next(); // 允许离开
    //     } else {
    //     next(false); // 取消离开
    //     }
    // },
    activated(){
        this.grade = this.$route.query.grade
        this.trem = this.$route.query.trem
        if(this.$route.query.type){
            this.question_ids = localStorage.getItem('question_ids');
            this.bank_index = this.$route.query.bank_index
            this.type_value = this.$route.query.type
            
            this.getQuestions()
        }
    },
    methods:{

        preview(){
            console.log(this.list)

            var list = JSON.parse(JSON.stringify(this.list))
            var result = []
            for(var i in list){

                for(var index in list[i].items){
                    var row = {}
                    row.wid = list[i].items[index].id
                    row.table = list[i].items[index].table
                    result.push(row)
                }
                
            }
            
            Http.getarticl(result).then((res) => {
                console.log(res)
                this.dialogVisible = true
                this.bank_data = res.data
            });

            
        },
        handleClose(){
            this.dialogVisible = false
        },
        changeStratify(e){
            
            if(e == 1){
                this.getStratify()
                this.form.stratify_name = 'A'
            }
            
        },

        getStratify(){
            Http.stratify().then((res) => {
                this.stratify_data = res.data
            });
        },

        changeQuestion(value){
            
            var list = JSON.parse(JSON.stringify(this.list))
            var result = []
            for(var i in list){
                if(list[i].items){
                    for(var index in list[i].items){
                        result.push(list[i].items[index].id)
                    }
                } 
            }
            // 已选择的材料ID
            localStorage.setItem('change_question_ids',result);

            this.question_index = value
            this.type_value = value
            localStorage.setItem('question_ids','');
            this.$router.push({ name: 'Questionbank',query:{type:value,trem:this.trem,grade:this.grade}});
        },
        clickQuestionType(index){
            this.question_index = index
        },
        clickType(item){
            
            if(this.type_change_data.length){
                var ind = this.type_change_data.indexOf(item.value)
                if(ind > 0){
                    this.type_change_data.splice(ind, 1);
                }else{
                    this.type_change_data.push(item.value)
                }
                
            }else{
                this.type_change_data.push(item.value)
            }
            const index = this.list.findIndex((element) => element.value === item.value);
            if (index!== -1) {
                this.list.splice(index, 1);
            } else {
                item.number = 0
                this.list.push(item);
            }
        },
        // 删除题型
        delParent(index,value){
            var ind = this.type_change_data.indexOf(value)
       
            this.type_change_data.splice(ind, 1);
            
            this.list.splice(index, 1);
        },
        handleClick(){},
        // 获取文章
        // score 每个题型总分值
        // bank_index   题型 0 阅读 1 应试
        // set_number 设置材料篇数
        // number   选择材料篇数
        getQuestions(){
            var params = {}
            params.bank_index = this.bank_index
            params.question_ids = this.question_ids
            Http.questions(params).then((res) => {
                var list = JSON.parse(JSON.stringify(this.list))
                for(var index in list){
                    if(list[index].value == this.type_value){
                        
                        if(list[index].items){
                            list[index].items = [...list[index].items,...res.data]
                        }else{
                            list[index].items = res.data
                        }
                        list[index].set_number = list[index].set_number?list[index].set_number:0
                        list[index].number = list[index].items.length
                        list[index].bank_index = this.bank_index
                        this.list[index].score = 0
                    }
                }

                this.list = list
                
            });
        },
        // 设置总分值
        inputScore(index){
            var set_number = this.list[index].set_number
            var data = this.list[index].items
            if(!set_number){
                this.$message({
                    type: 'error',
                    message: '请先设置材料篇数'
                });
                this.list[index].score = ''
                return false;
            }
            if(!data){
                this.$message({
                    type: 'error',
                    message: '请先选择材料'
                });
                this.list[index].score = ''
                return false;
            }
            var score = this.list[index].score
            var score = score/set_number;
            for(var i in data){
                data[i].score = score
            }
        },
        // 设置材料篇数
        inputSetnumber(index){
            
            var data = this.list[index].items
            if(!data){
                this.$message({
                    type: 'error',
                    message: '请先选择材料'
                });
                
                this.list[index].set_number = ''
                return false;
            }
            var set_number = this.list[index].set_number
            var score = this.list[index].score
     
            var score = score/set_number;
            // if(Number.isInteger(score)){
            //     this.$message({
            //         type: 'error',
            //         message: '设置分数必须是整数'
            //     });
                
            //     this.list[index].set_number = ''
            //     return false;
            // }
            for(var i in data){
                data[i].score = score?score:0
            }
        },
        // 输入分值
        // index 父级下标  qindex子级下标
        inputNumber(index,qindex){
            var data = this.list[index].items
            var total_score = 0;
            for(var i in data){
                total_score += parseInt(data[i].score)
            }
            this.list[index].score = total_score
        },

        delList(index,qindex){

            this.$confirm('此操作不可恢复，删除后可前往题库重新选题，是否确认删除?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDel(index,qindex)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },

        confirmDel(index,qindex){
            var id = this.list[index].items[qindex].id;
            var id = id.toString()
            var question_ids = this.question_ids.split(',')
            var ind = question_ids.indexOf(id)
            
            question_ids.splice(ind, 1);
            var question_ids = question_ids.join(',')
            this.question_ids = question_ids
            localStorage.setItem('question_ids',question_ids);
            var list = this.list[index].items
            list.splice(qindex, 1);
            this.list[index].items = list
            this.list[index].number--;

            console.log(this.list[index].set_number,this.list[index].score,this.list[index].items.length )

            if(this.list[index].set_number > this.list[index].items.length){
                
                var score = (this.list[index].score/this.list[index].items.length).toFixed(2);

                for(var i in  this.list[index].items){

                    this.list[index].items[i].score = score
                }

                this.list[index].set_number = this.list[index].items.length
            }
        },

        // 提交试题
        submit(){
            
            if(!this.verifyForm()){
                return false;
            }
            const loading = this.$loading({
                lock: true,
                text: '试卷生成中,请耐心等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            var cheat = this.form.cheat?1:0;
            var form = JSON.parse(JSON.stringify(this.form))
            form.cheat = cheat
            var params = {}
            params.setting  = form
            params.data     = this.list
            params.trem     = this.trem
            params.way      = this.activeName
            params.grade    = this.grade
            params.nids     = localStorage.getItem('nids');
        
            Http.create(params).then((res) => {
                loading.close()
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                }); 
                if(res.code){
                    this.$router.push({ name: 'Examlist'});
                    this.clearForm()
                }
            });
        },

        // 验证试题数据

        // 在 verifyForm 方法中添加校验
        verifyForm(){

            var loading = this.$loading({
                lock: true,
                text: '验证试卷...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });


            let total = 0;
            this.list.forEach(item => {
                total += Number(item.score) || 0;
            });
            
            if (total !== 100) {  // 修改为必须等于100分
                loading.close()
                this.$message.error('题型总分必须等于100分');
                return false;
            }
            
            var data = JSON.parse(JSON.stringify(this.list))
            for(var index in data){
                // 添加材料篇数校验
                if(!data[index].set_number || data[index].set_number < 1){
                    loading.close()
                    this.$message.error('请设置有效的材料篇数');
                    return false;
                }
                // 添加考题存在性检查
                if(!data[index].items || data[index].items.length === 0){
                    loading.close()
                    this.$message.error('请先选择考题材料');
                    return false;
                }
                // 修复分数校验逻辑
                var items = data[index].items
                for(var i in items){
                    if(!items[i].score || isNaN(items[i].score)){
                        loading.close()
                        this.$message.error('请填写有效的分值');
                        return false;
                    }
                }
            }
            loading.close()
            return true;
        },

        clearForm(){
            this.list = []
            this.type_change_data = []
            this.form = {
                allowtime:'',
                stratify:'0',
                cheat:'0',
                stratify_name:'A'
            }
        }

    }
}
</script>
<style lang="less" scoped>
.exam_form{
    margin-bottom: 20px;

    .el-input{
        width: 100px;
    }
}
.exam_form::v-deep .el-form-item__label{
    text-align: left;
}
.exam_form::v-deep .el-form-item{
    margin-bottom: 0px;
}
.type_box{

    display: inline-block;
    width: 100%;
}
.grid-content::v-deep .el-input__inner{
    text-align: center;
}
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.question_box{
    display: inline-block;
    width: 100%;
    .question_title_box{
        width: 100%;
        background-color: #F6F7FB;
        display: inline-block;
        box-sizing: border-box;
        padding: 20px;
        border-radius: 7px;
        line-height: 30px;

        span{
            float: left;
            font-size: 14px;
            margin-right: 20px;
        }
    }
    .transition-box{
        box-sizing: border-box;
        padding: 10px 20px;

        .grid-content{
            font-size: 14px;
            text-align: center;
        }
        .question_list_title{
            font-weight: 700;
        }
    }
}
.transition-box::v-deep .el-row{
    border-bottom: 1px #E8E8E8 solid;
    padding: 20px 0px;
}
.question_title_box::v-deep .el-link{
    float: right;
    margin-left: 10px;
}
.question_sign{
    display: inline-block;
    width: 100%;
    height: 40px;
    line-height: 23px;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
}
.content_paper{
    width: 100%;
}
.question_test{
    width: 80%;
    display: inline-block;
    line-height: 25px;
    box-sizing: border-box;
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
</style>